
/* =======================================================
   STEP CONFIGURATION
======================================================= */

const STEP_SCROLL_TARGETS = {
  1: "#startbuilding",
  2: "#message",
  3: "#select-box",
};

const MAX_STEP = 3;

let currentStep = getCurrentStepFromUrl() || 1;

/* =======================================================
   STEP BAR SELECTORS
======================================================= */

const STEP_BAR_ICON_SELECTOR = ".stepBar-module__step_item_icon";

/* =======================================================
   GET CURRENT STEP FROM URL
======================================================= */

function getCurrentStepFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const step = parseInt(params.get("step"), 10);

  if (!Number.isNaN(step) && step >= 1 && step <= MAX_STEP) {
    return step;
  }

  return null;
}

/* =======================================================
   STEP BAR CLICK HANDLER
======================================================= */

document.addEventListener("click", handleStepBarClick, true);

function handleStepBarClick(e) {
  const stepIcon = e.target.closest(STEP_BAR_ICON_SELECTOR);

  if (!stepIcon) {
    return;
  }

  if (!document.body.contains(stepIcon)) {
    return;
  }

  const step = getStepNumberFromIcon(stepIcon);

  if (!step) {
    console.log("Could not determine step from step bar:", stepIcon);
    return;
  }

  console.log("STEP BAR CLICK:", {
    step,
    className: stepIcon.className,
    text: stepIcon.textContent.trim(),
  });

  currentStep = step;

  const selector = STEP_SCROLL_TARGETS[step];

  setHash(selector);

  scrollAfterStepBarClick(step);
}

/* =======================================================
   DETERMINE STEP FROM POSITION
======================================================= */

function getStepNumberFromIcon(clickedIcon) {
  const icons = Array.from(
    document.querySelectorAll(STEP_BAR_ICON_SELECTOR)
  ).filter(isVisibleStepIcon);

  const index = icons.indexOf(clickedIcon);

  console.log("STEP BAR ICON INDEX:", {
    index,
    total: icons.length,
  });

  if (index >= 0 && index < MAX_STEP) {
    return index + 1;
  }

  return null;
}

/* =======================================================
   CHECK WHETHER STEP ICON IS VISIBLE
======================================================= */

function isVisibleStepIcon(element) {
  const style = window.getComputedStyle(element);
  const rect = element.getBoundingClientRect();

  return (
    style.display !== "none" &&
    style.visibility !== "hidden" &&
    rect.width > 0 &&
    rect.height > 0
  );
}

/* =======================================================
   SCROLL AFTER STEP BAR CLICK
======================================================= */

function scrollAfterStepBarClick(step) {
  const selector = STEP_SCROLL_TARGETS[step];

  if (!selector) {
    return;
  }

  const delays = [150, 350, 600, 900, 1300, 1800];

  delays.forEach((delay) => {
    setTimeout(() => {
      setHash(selector);

      const target = document.querySelector(selector);

      if (!target) {
        console.log("Step target not available yet:", selector);
        return;
      }

      console.log("STEP BAR SCROLL:", {
        step,
        selector,
        delay,
      });

      scrollToElement(target);
    }, delay);
  });
}

/* =======================================================
   EXISTING BUILD NAV BUTTON
======================================================= */

document.addEventListener("click", (e) => {
  const buildNavButton = e.target.closest("#buildnavbtn");

  if (!buildNavButton) {
    return;
  }

  console.log("BUILD NAV BUTTON CLICKED");

  currentStep = 1;

  setTimeout(() => {
    scrollToStep(1, false);
  }, 100);
});

/* =======================================================
   EXISTING EDIT BUTTON
======================================================= */

document.addEventListener("click", (e) => {
  const editButton = e.target.closest(
    ".boxItem-module__summary_btn_edit__mL"
  );

  if (!editButton) {
    return;
  }

  console.log("EDIT BUTTON CLICKED");

  currentStep = 1;

  clearHash();

  setTimeout(() => {
    scrollToStep(1, true);
  }, 800);
});

/* =======================================================
   EXISTING NEXT BUTTON
======================================================= */

document.addEventListener("click", (e) => {
  const nextButton = e.target.closest(
    ".QUICK_SUMMARY_BUTTON_NEXT_TS"
  );

  if (!nextButton) {
    return;
  }

  const nextStep = currentStep + 1;

  console.log("NEXT BUTTON CLICKED:", {
    currentStep,
    nextStep,
  });

  if (nextStep >= 1 && nextStep <= MAX_STEP) {
    currentStep = nextStep;

    setTimeout(() => {
      scrollToStep(currentStep, true);
    }, 500);
  }
});

/* =======================================================
   EXISTING BACK BUTTON
======================================================= */

document.addEventListener("click", (e) => {
  const backButton = e.target.closest(
    ".QUICK_SUMMARY_BUTTON_BACK_TS"
  );

  if (!backButton) {
    return;
  }

  const previousStep = currentStep - 1;

  console.log("BACK BUTTON CLICKED:", {
    currentStep,
    previousStep,
  });

  if (previousStep >= 1) {
    currentStep = previousStep;

    setTimeout(() => {
      scrollToStep(currentStep, true);
    }, 500);
  }
});

/* =======================================================
   SCROLL TO STEP
======================================================= */

function scrollToStep(step, updateHash = true) {
  const selector = STEP_SCROLL_TARGETS[step];

  if (!selector) {
    return;
  }

  waitForElement(selector, (element) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (updateHash) {
          setHash(selector);
        }

        scrollToElement(element);
      });
    });
  });
}

/* =======================================================
   SCROLL TO ELEMENT
======================================================= */

function scrollToElement(element) {
  if (!element) {
    return;
  }

  if (!document.body.contains(element)) {
    return;
  }

  const rect = element.getBoundingClientRect();

  const targetY = rect.top + window.scrollY;

  console.log("SCROLLING TO ELEMENT:", {
    id: element.id,
    targetY,
    currentY: window.scrollY,
  });

  window.scrollTo({
    top: targetY,
    behavior: "auto",
  });
}

/* =======================================================
   SET HASH
======================================================= */

function setHash(hash) {
  if (!hash) {
    return;
  }

  const cleanHash = hash.startsWith("#") ? hash : `#${hash}`;

  const newUrl =
    window.location.pathname +
    window.location.search +
    cleanHash;

  history.replaceState(null, "", newUrl);

  console.log("HASH:", cleanHash);
}

/* =======================================================
   CLEAR HASH
======================================================= */

function clearHash() {
  const newUrl =
    window.location.pathname +
    window.location.search;

  history.replaceState(null, "", newUrl);

  console.log("HASH CLEARED");
}

/* =======================================================
   WAIT FOR ELEMENT
======================================================= */

function waitForElement(selector, callback, timeout = 5000) {
  const existing = document.querySelector(selector);

  if (existing) {
    callback(existing);
    return;
  }

  const startTime = Date.now();

  const observer = new MutationObserver(() => {
    const element = document.querySelector(selector);

    if (element) {
      observer.disconnect();
      callback(element);
      return;
    }

    if (Date.now() - startTime > timeout) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => {
    observer.disconnect();
  }, timeout);
}

